import { type ReactElement } from 'react';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import { type VariableMessageSignProperties } from '../Sources/VariableMessageSign';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function VariableMessageSign(properties: VariableMessageSignProperties, layerOptions: ClusteredMarkerLayerOptions): ReactElement {
    return (
        <PopupTemplateWrapper iconId={properties.iconId} title={layerOptions.name}>
            <div className="">
                <h3>{properties.publicName}</h3>
                <div className="traffic-sign-details">
                    <figure className={'content ' + properties.vmsCssClass}>
                        <div className={'sign-link ' + properties.vmsCssClass}>
                            <div className="sign-item-container">
                                {properties.vmsCssClass === 'small' && (
                                    <div className="sign-item">
                                        {properties.messageSignVisible && (
                                            <div className="icon-area">
                                                <img alt="" src={properties.messageSignSource} className="sign-icon" />
                                                {properties.roadSignText && (
                                                    <span className="road-sign-text-container">
                                                        <span className="road-sign-text">{properties.roadSignText}</span>
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                        {properties.noMessageRowVisible ? (
                                            <div className="no-message-container">
                                                <span className="no-message-row">INGET MEDDELANDE</span>
                                            </div>
                                        ) : (
                                            <div className="text-area">
                                                <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow1 }} />
                                                <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow2 }} />
                                                <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow3 }} />
                                            </div>
                                        )}
                                    </div>
                                )}
                                {properties.vmsCssClass === 'big' && (
                                    <>
                                        <div className="sign-item">
                                            {properties.messageSignVisible && <img alt="" src={properties.messageSignSource} className="sign-icon" />}

                                            {properties.roadSignText && (
                                                <span className="road-sign-text-container">
                                                    <span className="road-sign-text">{properties.roadSignText}</span>
                                                </span>
                                            )}
                                        </div>
                                        <div className="sign-item">
                                            {properties.noMessageRowVisible && (
                                                <div className="no-message-container">
                                                    <span className="no-message-row">INGET MEDDELANDE</span>
                                                </div>
                                            )}

                                            <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow1 }} />
                                            <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow2 }} />
                                            <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow3 }} />
                                        </div>
                                    </>
                                )}
                                {properties.vmsCssClass === 'big double' && (
                                    <>
                                        <div className="sign-item height-50">
                                            {properties.noMessageRowVisible ? (
                                                !properties.connectedMessageSignVisible && (
                                                    <div className="no-message-container">
                                                        <span className="no-message-row">INGET MEDDELANDE</span>
                                                    </div>
                                                )
                                            ) : (
                                                <>
                                                    {properties.messageSignVisible && (
                                                        <div className="icon-area">
                                                            <img alt="" src={properties.messageSignSource} className="sign-icon" />
                                                            {properties.roadSignText && (
                                                                <span className="road-sign-text-container">
                                                                    <span className="road-sign-text">{properties.roadSignText}</span>
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div className="text-area">
                                                        <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow1 }} />
                                                        <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow2 }} />
                                                        <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow3 }} />
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <div className="sign-item height-50">
                                            {properties.connectedNoMessageRowVisible ? (
                                                !properties.noMessageRowVisible && (
                                                    <div className="no-message-container">
                                                        <span className="no-message-row">INGET MEDDELANDE</span>
                                                    </div>
                                                )
                                            ) : (
                                                <>
                                                    {properties.connectedMessageSignVisible && (
                                                        <div className="icon-area">
                                                            <img alt="" src={properties.connectedMessageSignSource} className="sign-icon" />
                                                            {properties.connectedRoadSignText && (
                                                                <span className="road-sign-text-container">
                                                                    <span className="road-sign-text">{properties.connectedRoadSignText}</span>
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div className="text-area">
                                                        <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow1 }} />
                                                        <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow2 }} />
                                                        <span className="text-row" dangerouslySetInnerHTML={{ __html: properties.textRow3 }} />
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </figure>
                </div>

                <div className="d-flex justify-content-between mt-1">
                    <a href={properties.url}>Visa mer &raquo;</a>
                    <div id="popup-favorite-toggler" />
                </div>
            </div>
        </PopupTemplateWrapper>
    );
}
